import { css } from "lit";

export const notificationCardStyles = css`
  :host {
    display: block;
  }

  .notification-card {
    display: flex;
    min-width: 240px;
    min-height: 64px;
    padding: var(--sds-size-space-400) 12px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    cursor: pointer;
    transition: background-color 0.2s ease;
    box-sizing: border-box;
  }

  .notification-card:hover {
    background: var(--sds-color-background-default-tertiary);
  }

  .notification-card.unread {
    background: var(--sds-color-background-default-secondary);
  }

  .notification-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 47.498px;
    height: 19px;
  }

  .creator-avatar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .creator-avatar-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }

  .creator-avatar-fallback {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--sds-color-brand-default), var(--sds-color-accent-default));
    color: var(--sds-color-text-on-color-default);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: var(--sds-typography-weight-semibold);
    font-size: var(--sds-typography-body-size-medium);
    border: 2px solid var(--sds-color-border-default-secondary);
  }

  .notification-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 4px;
  }

  .creator-name {
    color: var(--sds-color-text-default-default);

    /* Single Line/Label Base */
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-style: normal;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 100%;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification-text {
    color: var(--sds-color-text-default-default);

    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 150%;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notification-action-button {
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-small);
    font-style: normal;
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 100%;
  }
`;
